import React from 'react';
import Form from 'antd/lib/form';
import 'antd/lib/form/style/index.css';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';
var InputAthlete = function (props) { return (React.createElement(Form.Item, { label: React.createElement("strong", null, "Add athletes to team"), colon: false },
    React.createElement(Select, { size: 'large', disabled: props.isDisabled || !props.categoryDoc, showSearch: true, optionFilterProp: 'children', filterOption: function (input, option) { return option.props.children && option.props.children[0].toLowerCase().indexOf(input.toLowerCase()) >= 0; }, value: '', onChange: function (athleteId) {
            props.handleAddAthlete(athleteId);
        } }, props.athleteDocs
        .filter(function (athlete) { return athlete.categoryId === (props.categoryDoc && props.categoryDoc.id); })
        .sort(function (a, b) { return a.name.localeCompare(b.name); })
        .map(function (athlete) {
        return props.excludeAthleteDocs.findIndex(function (a) { return a.id === athlete.id; }) > -1
            ? null
            : (React.createElement(Select.Option, { key: athlete.id, value: athlete.id },
                athlete.name,
                !athlete.teamId && React.createElement("em", null,
                    " ",
                    React.createElement("small", null, "(No team)"))));
    })))); };
export default InputAthlete;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormTeamPage/FormTeam/InputAthlete.tsx
// module id = 1196
// module chunks = 0